<template>
  <div class="footPage">
    <div class="youqing">
      <span>友情链接:</span>
      <a href="https://www.bjhdedu.cn/" target="_blank">海淀教育网</a>
      <a href="https://www.ncsti.gov.cn/kjdt/scyq/zgckxc/index.html" target="_blank">中关村科学城</a>
      <a href="https://kw.beijing.gov.cn/index.html" target="_blank">北京市科委、中关村管委会</a>
      <a href="https://xwpx.eduyun.cn/" target="_blank">全国校外培训监管与服务综合平台</a>
    </div>
    <div class="foot-tex mt">主办：北京正信民生科技创新服务联盟</div>
    <div class="foot-tex">技术支持：北京易魔方科技集团有限公司</div>
    <div class="foot-tex">
      <a href="https://beian.miit.gov.cn/#/Integrated/index" tarrget="_blank">京ICP备18050245号-5</a>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010102007553">京公网安备11010102007553号</a>
    </div>
  </div>
</template>
<script>
export default {
  name: "footPage",
  data() {
    return {}
  },
  components: {},
  created() {

  },
  methods: {},
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.footPage {
  width: 100%;
  height: 190px;
  background-image: linear-gradient(0deg,
    #4fa5ff 0%,
    #0e7eff 100%);
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 35px 0;
  .foot-tex {
    font-size: 14px;
    color: #ffffff;
    text-align: center;

    &.mt {
      margin-top: 20px;
    }
    a {
      color: #ffffff;
      font-size: 14px;
      margin-left: 30px;
    }
  }
  .youqing {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    a {
      font-size: 14px;
      color: #ffffff;
      margin-left: 50px;
    }
    span {
      font-size: 14px;
      color: #ffffff;
    }
  }
}
</style>


